import React, { FC } from 'react';
import {
	SummaryBeantragteFoerderquote,
	SummaryBeantragteFoerderung,
	SummaryDatumDerEinreichung,
	SummaryGeplanteProjektAusgabe,
	SummaryNameDerOrganisation,
	SummaryOrganisationAntragberechtigtAls,
	SummaryProjektTitel,
	SummaryTitel,
} from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteSummary';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import AbschlussSeiteBox, { GefoerderteSummeProgrammInfo } from '../../../../antrag-components/AbschlussSeiteBox';

const AbschlussAntragStartUp: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<SummaryTitel />
			<AbschlussSeiteBox>
				<SummaryDatumDerEinreichung />

				<SummaryProjektTitel />

				<SummaryNameDerOrganisation />
				<SummaryOrganisationAntragberechtigtAls />

				<SummaryGeplanteProjektAusgabe />
				<SummaryBeantragteFoerderung />
				<SummaryBeantragteFoerderquote />

				<GefoerderteSummeProgrammInfo application={application} />
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussAntragStartUp;
